var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPriceUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.81635 9.96833C3.52346 10.2612 3.52346 10.7361 3.81635 11.029C4.10924 11.3219 4.58412 11.3219 4.87701 11.029L9.25357 6.65243L9.25371 15.8016C9.2536 16.2158 9.58931 16.5517 10.0035 16.5518C10.4177 16.5519 10.7536 16.2162 10.7537 15.802L10.7536 6.65248L15.123 11.0219C15.4159 11.3148 15.8908 11.3148 16.1837 11.0219C16.4766 10.729 16.4766 10.2542 16.1837 9.96127L10.5339 4.31147C10.241 4.01857 9.76611 4.01857 9.47321 4.31147L3.81635 9.96833Z",
    fill: "#05C46B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceUp);
export default __webpack_public_path__ + "static/media/price-up.238758df.svg";
export { ForwardRef as ReactComponent };